import React from 'react'
import { IoMdCloseCircleOutline } from 'react-icons/io'
import { MdOutlineWatchLater } from 'react-icons/md'

import { ERewardHistoryStatus } from '@/libs/apis/queries/use-get-list-reward-history-query'

type TRewardHistoryStatus = {
  readonly status: ERewardHistoryStatus
  readonly date?: string
  readonly variant?: 'date' | 'default'
}

export default function RewardHistoryStatus({
  status,
  date,
  variant = 'date',
}: TRewardHistoryStatus) {
  const selectedStatus = {
    SUCCESS: {
      label: variant === 'date' ? date : 'Success',
      icon: null,
      bgClass: variant === 'date' ? '' : 'bg-success-green-050',
      textClass: `text-xs font-normal ${
        variant === 'date' ? 'text-pop-grey-600' : 'text-success-green-600'
      }`,
    },
    PENDING: {
      label: 'Pending',
      icon: (
        <MdOutlineWatchLater
          className='h-3 w-3 text-pop-yellow-600'
          data-testid='watch_later_icon'
        />
      ),
      bgClass: 'bg-pop-yellow-50',
      textClass: 'text-pop-yellow-600',
    },
    FAILED: {
      label: 'Failed',
      icon: (
        <IoMdCloseCircleOutline className='h-3 w-3 text-pop-red-600' data-testid='cancel_icon' />
      ),
      bgClass: 'bg-pop-red-100',
      textClass: 'text-pop-red-600',
    },
  }[status]

  return (
    <div
      className={`flex flex-row items-center gap-1 rounded-full ${
        selectedStatus.icon && 'px-2 py-1'
      } ${selectedStatus.bgClass}`}
    >
      {selectedStatus?.icon}
      <span className={`text-xs font-medium ${selectedStatus.textClass} sentry-mask`}>
        {selectedStatus.label}
      </span>
    </div>
  )
}
